const menuKey = "users.option";

const names = {
  ".dashboard": "Dashboard",
  ".documents": "Kn•Mind",
  ".notifications": "Notificaciones",
  ".payments": "Pagos",
  ".followup": "Seguimiento",
  ".KnotionBank": "Knotion Bank",
  ".planner": "Planificador",
  "": "Usuarios",
  ".lessons": "Clases",
  ".groups": "Grupos",
  ".evaluation": "Evaluación",
  ".payments.catalogs.concepts": "Conceptos",
  ".payments.catalogs.articles": "Artículos",
  ".payments.loan": "Becas",
  ".payments.settings": "Configuración de ciclo",
  ".payments.conciliation": "Conciliación de pagos",
  ".payments.store": "Administración de tienda",
  ".payments.list": "Listado de pagos",
  ".customSubjects": "Materias institucionales",
  ".evaluationReport": "Periodos de evaluación y boletas",
  ".evaluationModel": "Criterios de evaluación",
  ".callcenter.dashboard": "Dashboard",
  ".callcenter.transactions": "Pagos",
  ".callcenter.accountStatus": "Edo. Cuenta",
  ".profile": "Perfil",
  ".payment": "Pago",
  ".history": "Hist. Pagos",
};

export const menuCopyFilter = function (value) {
  const name = names[value.replaceAll(menuKey, "")];

  return name ? name : value;
};
